var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{staticStyle:{"overflow-x":"hidden"},attrs:{"name":"complete-profile","maxWidth":1200,"width":"100%","height":"auto","scrollable":true,"adaptive":true}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body position-relative"},[_c('button',{staticClass:"btn close-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$modal.hide('complete-profile')}}},[_c('i',{staticClass:"fas fa-times"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-primary"},[_c('resource',{attrs:{"title":"Ändern","resource":"customerProfile","original":_vm.customerProfile,"attributes":[
              {
                name: 'sex',
                label: 'Geschlecht',
                type: 'SexSelector'
              },
              {
                name: 'postcode',
                label: 'PLZ',
                type: 'PostcodeSelector'
              },
              {
                name: 'birthday',
                label: 'Geburtsdatum',
                type: 'BirthdaySelector',
                withRandomSelector: false,
                onlyDate: true
              }
            ],"header-class":"bg-primary"},on:{"resource-persisted":function($event){return _vm.refresh()}}},[_c('div',{staticClass:"text-light",attrs:{"slot":"title"},slot:"title"},[_vm._v("\n              Vervollständigen Sie ihr Profil bevor Sie\n              "+_vm._s(_vm.appCurrency)+" kaufen können.\n            ")])])],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }